import { render, staticRenderFns } from "./SwapNotification.vue?vue&type=template&id=521b2120&scoped=true&"
import script from "./SwapNotification.vue?vue&type=script&lang=ts&"
export * from "./SwapNotification.vue?vue&type=script&lang=ts&"
import style0 from "./SwapNotification.vue?vue&type=style&index=0&id=521b2120&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521b2120",
  null
  
)

export default component.exports